import React, { FC } from 'react'

import { FormattedMessage } from 'react-intl'

import { Gender } from 'common-constants/api6.types'
import { GQLGender } from 'generated-graphql/graphql'

interface MessageGiftProps {
  vipDays: number | undefined
  gender: Gender | GQLGender | null | undefined
}

export const MessageVipView: FC<MessageGiftProps> = ({ vipDays, gender }) => (
  <FormattedMessage
    id="profile.vip.present.gift"
    defaultMessage="{gender, select, M {Подарил} F {Подарила} other {Подарил}} VIP-статус на {vipDays} дней."
    values={{
      vipDays,
      gender,
    }}
  />
)
